module.exports = __webpack_public_path__ + "media/assets/images/category/NewYear@2x-1c62f11d9f7747f76aaf054fbe55f0dd.png";